import React, {Component} from "react";
import Img1 from "../../../images/affiliate-marketing.png";
import Img2 from "../../../images/baby.png";
import Img3 from "../../../images/paper-plane.png";

class Architecture extends Component{

    constructor(props){
        super(props);
        this.state = {
            style : {
                textAlign : "center",
                margin : "4rem 0",
            }
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <h2 style={this.state.style}>Defi WLOCT Architecture</h2>
                <div className="architecure-widget">
                    <div className="architecture-flex">
                        <div className="architecture-card">
                            <img src={Img1} />
                            <p className="small-txt">HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only.</p>
                        </div>
                        <div className="architecture-card">
                            <img src={Img2} />
                            <p className="small-txt">HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only.</p>
                        </div>
                    </div>
                    <div className="architecture-flex">
                        <div className="architecture-card">
                            <img src={Img3} />
                            <p className="small-txt">HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Architecture;

